import { Component, EventEmitter, Input, Output } from '@angular/core';

interface IBrand {
  id: number;
  name: string;
  avatarUrl: string;
  image: string;
}

@Component({
  selector: 'brand-list',
  standalone: true,
  imports: [],
  templateUrl: './brand-list.component.html',
  styleUrl: './brand-list.component.scss'
})
export class BrandListComponent {
  @Input() public brands: IBrand[];
  @Output() public brandClick: EventEmitter<IBrand>;

  constructor() {
    this.brandClick = new EventEmitter<IBrand>();
  }

  public onBrandClick(brand: IBrand): void {
    this.brandClick.emit(brand);
  }
}
